export default __webpack_public_path__ + "static/media/ellipseThemeSwitcher.c7c93769.svg";